import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  close() {
    this.element.classList.remove('is-active')
    document.cookie = `inbound_guidance_close=true; max-age=86400; path=/`
  }
}
